<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="做任务名称">
          <el-input placeholder="请输入做任务名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="任务分类">
          <el-select size="small" v-model="formInline.category_id" >
            <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加做任务</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="image" label="logo">
            <template slot-scope="scope">
              <div v-if="scope.row.image">
                <img :src="scope.row.image" width="30px" height="30px"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="category.name" label="任务分类"></el-table-column>
          
            <el-table-column prop="name" label="任务名称"></el-table-column>
            <el-table-column prop="intro" label="任务简介"></el-table-column>
            <el-table-column prop="is_audit" label="是否需要审核">
              <template slot-scope="scope">
                <span v-if="scope.row.is_audit == 0">无需审核</span>
                <span v-if="scope.row.is_audit == 1">需要审核</span>
              </template>

            </el-table-column>

            <el-table-column prop="code" label="任务类型">
              <template slot-scope="scope">
                <span v-if="scope.row.code == 'common'">普通任务</span>
                <span v-if="scope.row.code == 'sport'">微信运动任务</span>
              </template>

    
            </el-table-column>

            <el-table-column prop="point" label="任务奖励积分"></el-table-column>


            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="jumpClick(scope.row)" type="text" size="small">任务记录</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :dotask_id="dotask_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import DotaskApi from '@/api/dotask.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          category_id:-1,
        },

        open_add:false,
        open_edit:false,
        dotask_id:"",
        dialogVisible:false,
        category:[]
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      this.getCategory()
    },
    methods: {
      jumpClick(item){
        this.$router.push({
          path: '/plus/dotask/index/log',
          query: {
            dotask_id: item.dotask_id
          }
        });
      },
      getCategory(){
      let self = this;
      let Params = {};
      DotaskApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          if(data.data.vars.values!='[]'){
            if(!data.data.vars.values.category){
              this.category = [];
            }else{
              var arr = [{
                id: -1,
                name:"全部",
                val:0,
               }
              ]

              this.category = data.data.vars.values.category;
              this.category = arr.concat(this.category);
            }
          }
          console.log(" this.category", this.category);
          
        })
        .catch(error => {});
    },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//做任务标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        DotaskApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      addClick(row) {
  
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.dotask_id = row.dotask_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DotaskApi.del(
              {
                dotask_id: row.dotask_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/dotask/index/index.vue